// components/ExportSettingsModal.js
import React from 'react'
import './ExportSettingsModal.css'

// SVG Flaggen-Komponenten
const FlagDE = () => (
  <svg viewBox='0 0 640 480' className='export-settings-flag-svg'>
    <path fill='#000' d='M0 0h640v160H0z' />
    <path fill='#DD0000' d='M0 160h640v160H0z' />
    <path fill='#FFCE00' d='M0 320h640v160H0z' />
  </svg>
)

const FlagGB = () => (
  <svg viewBox='0 0 640 480' className='export-settings-flag-svg'>
    <path fill='#012169' d='M0 0h640v480H0z' />
    <path fill='#FFF' d='m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0h75z' />
    <path fill='#C8102E' d='m424 281 216 159v40L369 281h55zm-184 20 6 35L54 480H0l240-179zM640 0v3L391 191l2-44L590 0h50zM0 0l239 176h-60L0 42V0z' />
    <path fill='#FFF' d='M241 0v480h160V0H241zM0 160v160h640V160H0z' />
    <path fill='#C8102E' d='M0 193v96h640v-96H0zM273 0v480h96V0h-96z' />
  </svg>
)

const FlagFR = () => (
  <svg viewBox='0 0 640 480' className='export-settings-flag-svg'>
    <path fill='#fff' d='M0 0h640v480H0z' />
    <path fill='#00267f' d='M0 0h213.3v480H0z' />
    <path fill='#f31830' d='M426.7 0H640v480H426.7z' />
  </svg>
)

const FlagES = () => (
  <svg viewBox='0 0 640 480' className='export-settings-flag-svg'>
    <path fill='#AA151B' d='M0 0h640v480H0z' />
    <path fill='#F1BF00' d='M0 120h640v240H0z' />
  </svg>
)

const FlagIT = () => (
  <svg viewBox='0 0 640 480' className='export-settings-flag-svg'>
    <path fill='#009246' d='M0 0h213.3v480H0z' />
    <path fill='#fff' d='M213.3 0h213.4v480H213.3z' />
    <path fill='#CE2B37' d='M426.7 0H640v480H426.7z' />
  </svg>
)

// Original-Option (Dokument-Icon)
const FlagOriginal = () => (
  <svg viewBox='0 0 640 480' className='export-settings-flag-svg'>
    <rect width='640' height='480' fill='#f8f9fa' stroke='#dee2e6' strokeWidth='2' rx='8' />
    <path d='M 200 120 L 200 360 L 440 360 L 440 200 L 320 200 L 320 120 Z' 
          fill='none' 
          stroke='#6c757d' 
          strokeWidth='12' 
          strokeLinecap='round' 
          strokeLinejoin='round' />
    <path d='M 320 200 L 440 200' 
          fill='none' 
          stroke='#6c757d' 
          strokeWidth='12' 
          strokeLinecap='round' />
  </svg>
)

const LANGUAGES = [
  { code: 'original', name: 'Original', FlagComponent: FlagOriginal, nativeName: 'Nicht übersetzen' },
  { code: 'de', name: 'Deutsch', FlagComponent: FlagDE, nativeName: 'Deutsch' },
  { code: 'en', name: 'English', FlagComponent: FlagGB, nativeName: 'English' },
  { code: 'fr', name: 'Français', FlagComponent: FlagFR, nativeName: 'Français' },
  { code: 'es', name: 'Español', FlagComponent: FlagES, nativeName: 'Español' },
  { code: 'it', name: 'Italiano', FlagComponent: FlagIT, nativeName: 'Italiano' }
]

function ExportSettingsModal ({
  isOpen,
  onClose,
  onConfirm,
  selectedLanguage = 'original'
}) {
  if (!isOpen) return null

  const [currentLanguage, setCurrentLanguage] = React.useState(selectedLanguage)

  const handleConfirm = () => {
    onConfirm(currentLanguage)
    onClose()
  }

  return (
    <div className='export-settings-modal-overlay' onClick={onClose}>
      <div
        className='export-settings-modal-content'
        onClick={e => e.stopPropagation()}
      >
        <div className='export-settings-modal-header'>
          <div className='export-settings-modal-header-title'>
            <svg
              className='export-settings-modal-icon'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
            >
              <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
              <polyline points='7 10 12 15 17 10' />
              <line x1='12' y1='15' x2='12' y2='3' />
            </svg>
            <h3 className='export-settings-modal-title'>Exporteinstellungen</h3>
          </div>
          <button className='export-settings-modal-close-btn' onClick={onClose} aria-label='Schließen'>
            <svg
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
            >
              <line x1='18' y1='6' x2='6' y2='18' />
              <line x1='6' y1='6' x2='18' y2='18' />
            </svg>
          </button>
        </div>

        <div className='export-settings-modal-body'>
          <p className='export-settings-modal-description'>
            Wählen Sie die Sprache für den Export (oder "Original" für keine Übersetzung):
          </p>

          <div className='export-settings-language-selection'>
            {LANGUAGES.map(lang => {
              const FlagComponent = lang.FlagComponent
              return (
              <label
                key={lang.code}
                className={`export-settings-language-option ${
                  currentLanguage === lang.code ? 'export-settings-language-option-selected' : ''
                }`}
              >
                <input
                  type='radio'
                  name='export-settings-language'
                  value={lang.code}
                  checked={currentLanguage === lang.code}
                  onChange={e => setCurrentLanguage(e.target.value)}
                  className='export-settings-language-radio'
                />
                <div className='export-settings-language-flag-wrapper'>
                  <FlagComponent />
                </div>
                <div className='export-settings-language-info'>
                  <span className='export-settings-language-name'>{lang.name}</span>
                  <span className='export-settings-language-native'>{lang.nativeName}</span>
                </div>
                {currentLanguage === lang.code && (
                  <svg
                    className='export-settings-language-check-icon'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth='3'
                  >
                    <polyline points='20 6 9 17 4 12' />
                  </svg>
                )}
              </label>
              )
            })}
          </div>
        </div>

        <div className='export-settings-modal-actions'>
          <button className='export-settings-btn-cancel' onClick={onClose}>
            Abbrechen
          </button>
          <button className='export-settings-btn-export' onClick={handleConfirm}>
            <svg
              className='export-settings-btn-export-icon'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
              strokeWidth='2'
            >
              <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
              <polyline points='7 10 12 15 17 10' />
              <line x1='12' y1='15' x2='12' y2='3' />
            </svg>
            Exportieren
          </button>
        </div>
      </div>
    </div>
  )
}

export default ExportSettingsModal

